__webpack_require__.p = "/coin-dash/";